"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
exports.twoLastRatingDaysQuery = graphql_tag_1.default("query twoLastRatingDays {\n  ratingDates(count: 2) {\n    id\n    date\n  }\n}");
